import { For } from 'solid-js'
import ConsentSwitch from './ConsentSwitch'
import { COPY, type CategoryInfo } from './copy'

export default function ConsentCategoryRow(props: {
  category: CategoryInfo
  checked: boolean
  onChange?: (v: boolean) => void
  /** GPC on: marketing is forced off */
  gpcLocked?: boolean
}) {
  const c = props.category
  const sw = `tc-${c.id}`
  const desc = `tc-${c.id}-desc`
  const locked = c.id === 'necessary'
  return (
    <div class="border-t border-[color:var(--tc-border-soft)] py-3" data-testid={`consent-row-${c.id}`}>
      <div class="flex items-start justify-between gap-4">
        <div class="min-w-0">
          <label for={sw} class="block text-[14px] font-semibold text-[color:var(--tc-text)]">
            {c.label}
          </label>
          <p id={desc} class="m-0 mt-1 text-[12px] text-[color:var(--tc-text-2)]">
            {c.description}
            {locked ? <span class="ml-1 font-semibold text-[color:var(--tc-success)]">{COPY.alwaysOn}</span> : null}
            {props.gpcLocked ? <span data-testid="consent-gpc-locked" class="ml-1 font-semibold text-[color:var(--tc-success)]">{COPY.gpcLocked}</span> : null}
          </p>
        </div>
        <ConsentSwitch id={sw} checked={props.checked} locked={locked} forcedOff={props.gpcLocked} describedBy={desc} onChange={props.onChange} />
      </div>
      <details class="mt-2">
        <summary class="cursor-pointer text-[12px] text-[color:var(--tc-accent)]">{COPY.viewCookies}</summary>
        <div class="overflow-x-auto">
          <table class="mt-2 w-full text-left text-[12px] text-[color:var(--tc-text-2)]">
            <thead>
              <tr>
                <th class="py-1 pr-3 font-semibold">Name</th>
                <th class="py-1 pr-3 font-semibold">Provider</th>
                <th class="py-1 pr-3 font-semibold">Purpose</th>
                <th class="py-1 font-semibold">Duration</th>
              </tr>
            </thead>
            <tbody>
              <For each={c.cookies}>
                {(k) => (
                  <tr class="border-t border-[color:var(--tc-border-soft)]">
                    <td class="py-1 pr-3 break-all">{k.name}</td>
                    <td class="py-1 pr-3">{k.provider}</td>
                    <td class="py-1 pr-3">{k.purpose}</td>
                    <td class="py-1">{k.duration}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </div>
      </details>
    </div>
  )
}
